<div class="review-submit-container">
  @if (isSubmitting || isSavingDraft) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <form #reviewSubmitForm="ngForm" class="review-submit-form">
    <div class="section-header mb-3">
      <h5>Review & Submit</h5>
    </div>

    <div class="row">
      <div class="col-12 mb-3">
        <label class="form-label">Additional Comments</label>
        <textarea
          class="form-control"
          [(ngModel)]="formData.additionalComments"
          name="additionalComments"
          rows="6">
        </textarea>
        <small class="text-muted">Optional: Add any additional information or special instructions for this {{ parentWizard?.wizardTitle || 'request' }}.</small>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="d-flex justify-content-end gap-2">
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="onSaveDraft()"
            [disabled]="isSubmitting || isSavingDraft">
            @if (isSavingDraft) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            }
            {{ isSavingDraft ? 'Saving...' : 'Save Draft' }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="onSubmitRequest()"
            [disabled]="isSubmitting || isSavingDraft">
            @if (isSubmitting) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            }
            {{ isSubmitting ? 'Submitting...' : 'Submit Request' }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
